




import { Component, Mixins } from "vue-property-decorator";
import { ArrowKinds } from "../../domain/drawing";
import OptionDropDownSelector from "../system/selectors/OptionDropDownSelector.vue";
import { ModelEditableMixin, DisableableMixin } from "../system/mixins";
import { StandardOption } from "../system/selectors/mixins";

@Component({
  components: {
    selector: OptionDropDownSelector,
  },
})
export default class ArrowKindDropDownSelector extends Mixins(ModelEditableMixin, DisableableMixin) {
  data(): any {
    return {
      options: [
        new StandardOption<ArrowKinds>("なし", ArrowKinds.None),
        new StandardOption<ArrowKinds>("始点", ArrowKinds.ArrowFrom),
        new StandardOption<ArrowKinds>("終点", ArrowKinds.ArrowTo),
        new StandardOption<ArrowKinds>("両端", ArrowKinds.ArrowBoth),
      ],
    };
  }
}
